<template>
    <div class="DocumentListing">
        <div class="container-fluid">
            <div class="row">
                <h3>Employee Document Listing</h3>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>List Type:</label>
                        <select class="form-control" v-model="ListType" @change="GetData">
                            <option value="ApprovalList">Notes Requiring this Employee's Review</option>
                            <option value="ReturnedList">Returned Notes Requiring this Employee to Correct</option>
                            <option value="DraftsList">Notes in this Employee's Drafts</option>
                        </select>
                    </div>
                </div>
            </div>

            <b-row style="overflow-x:auto;">
                <b-col>
                    <vuetable :fields="Fields"
                              :data="FieldData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable">
                    </vuetable>
                </b-col>
            </b-row>

            <b-row v-if="ListType == 'ReturnedList'">
                <b-col>
                    <button @click="SendNotesBackToReviewer()" class="form-control btn btn-danger">SEND ALL NOTES BACK TO REVIEWER</button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        props: [
            'EmployeeId'
        ],
        data: function () {
            return {
                ListType: null,
                Filters: {},
                FieldData: [],
                Fields: [
                    {
                        name: 'ChartName',
                        title: 'ChartName',
                        sortField: 'ChartName'
                    },
                    {
                        name: "DocumentName",
                        title: "Document",
                        sortField: 'DocumentName'
                    },
                    {
                        name: 'AuthorEmployeeName',
                        title: "Author",
                        sortField: 'AuthorEmployeeName'
                    },
                    {
                        name: 'EffectiveDate',
                        title: "Document Date",
                        callback: 'formatDate|MM/DD/YY',
                        sortField: 'EffectiveDate'
                    },
                    
                ],
            };
        },
        methods: {
            GetData() {
                switch (this.ListType) {
                    case "ApprovalList":
                        this.Filters.AuthorEmployeeID = null
                        this.Filters.ApproverEmployeeID = this.EmployeeId
                        this.Filters.DocumentStatus = "Submitted For Approvals"
                        this.Filters.DocumentWasReturned = null
                        break;
                    case "ReturnedList":
                        this.Filters.AuthorEmployeeID = this.EmployeeId
                        this.Filters.ApproverEmployeeID = null
                        this.Filters.DocumentStatus = "Draft"
                        this.Filters.DocumentWasReturned = true
                        break;
                    case "DraftsList":
                        this.Filters.AuthorEmployeeID = this.EmployeeId
                        this.Filters.ApproverEmployeeID = null
                        this.Filters.DocumentStatus = "Draft"
                        this.Filters.DocumentWasReturned = null
                        break;
                    default:
                        return;
                }
                this.$MasterAPI.ExecuteRequest("GET", "DocumentListings", this.Filters, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.FieldData = response.data.data;
            },

            SendNotesBackToReviewer() {
                this.$MasterAPI.ExecuteRequest("POST", "Documents/SendNotesBackToReviewer", {EmployeeID: this.EmployeeId }, this.SendNotesBackToReviewerSuccess, () => { }, true);
            },
            SendNotesBackToReviewerSuccess(response) {
                this.GetData();
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
            
        },
        components: {
            Vuetable,
            flatPickr,
            vSelect
        },
        mounted() {

        },
        computed: {
        }
    }
</script>
